import { getAccountDebt, GetAccountDebtResponse, DebtRow } from 'admin/actions/account';
import Grid from 'admin/components/atoms/Grid';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const GridRow = styled(Grid.Container)`
  padding: 6px 0;
`;
const Debts = ({ accountId }: { accountId?: string }) => {
  const [debts, setDebts] = useState<GetAccountDebtResponse>();

  const fetchDebts = (query = '') => {
    if (accountId) getAccountDebt(accountId, query).then(setDebts);
  };

  useEffect(() => {
    fetchDebts();
  }, [accountId]);

  if (!debts?.rows?.length) return null;

  return (
    <>
      {debts.rows.map((row: DebtRow) => (
        <React.Fragment key={row.bear_point_shop_account_id}>
          <GridRow>
            <Grid.Item size={3}>
              <span style={{ display: 'inline-block', width: '6em', textAlign: 'right' }}>
                {row.point_amount.toLocaleString()}
              </span>
            </Grid.Item>
            <Grid.Item size={3}>
              {row.bear_point_shop_name}（{row.shop_organization_name}）
            </Grid.Item>
            <Grid.Item size={3}>{moment(row.created_at).format('YYYY/MM/DD HH:mm')}</Grid.Item>
            <Grid.Item size={3}>{moment(row.updated_at).format('YYYY/MM/DD HH:mm')}</Grid.Item>
          </GridRow>
          <Grid.Divider margin="0" />
        </React.Fragment>
      ))}
    </>
  );
};

export default Debts;
